export const TOOLS_LIST = "TOOLS_LIST";
export const LAST_LOGGED_IN_TOOL = "LAST_LOGGED_IN_TOOL";
export const MENU_STATE = "MENU_STATE";
